<template>
  <article>
    <div class="filter mt-20 mb-20">
      <div class="filter__item">
        <adRegisterSelect v-model="filters.arid" :lists.sync="registerLists"/>
      </div>
      <div class="filter__item">
        <div class="filter__name">用户UID：</div>
        <el-input v-model="filters.uid" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">状态：</div>
        <el-select class="filter__input" size="mini" v-model="filters.status">
          <el-option :label="item.name" :value="item.value" v-for="(item, index) in statusList" :key="index"></el-option>
        </el-select>
      </div>
      <button class="blue-small-btn mr-10" @click="getList">搜索</button>
      <button class="blue-small-btn mr-10" @click="download">导出</button>
      <button class="blue-small-btn ml-auto" @click="editDialog = !editDialog">新建</button>
    </div>
    <el-table ref="dataTable" :data="lists" highlight-current-row v-loading="listLoading" style="width: 100%;" class="" height="600">
      <el-table-column prop="apid" label="ID" width="" align="center">
      </el-table-column>
      <el-table-column prop="arid" label="广告ID" width="" align="center">
      </el-table-column>
      <el-table-column prop="title" label="项目" width="" align="center">
      </el-table-column>
      <el-table-column prop="" label="额度" width="" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.mode == 0" >{{ scope.row.quota }}</div>
          <div v-if="scope.row.mode == 1" >{{ scope.row.quota }}单</div>
        </template>
      </el-table-column>
      <el-table-column prop="uid" label="用户ID" width="" align="center">
      </el-table-column>
      <el-table-column label="昵称" width="" align="center">
        <template slot-scope="scope">
          <router-link :to="{path: '/adUserDetail', query: {uid: scope.row.uid}}">{{scope.row.nickname}}</router-link>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" width="" align="center">
      </el-table-column>
      <el-table-column prop="status" label="状态" width="" align="center" sortable>
        <template slot-scope="scope">
          <el-select v-model="scope.row.status" size="small" @change="changeInfo(scope.$index)">
            <el-option v-for="item in statusList.slice(1)" :key="item.value" :label="item.name" :value="item.value"> </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="date" label="日期" width="" align="center" sortable>
      </el-table-column>
      <el-table-column prop="" label="创建时间" width="100" align="center">
        <template slot-scope="scope">
          <div v-html="formatTimeStamp(scope.row.create_time)"></div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180" align="center" fixed="right">
        <template slot-scope="scope">
          <div class="flex jcc">
            <el-button type="primary" plain size="mini" @click="editInfo(scope.$index)">编辑</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination layout="total, sizes, pager, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="filters.l" :page-sizes="[20, 50, 80, 100, 200]" :total="filters.total" :current-page="filters.p" class="tac mt-36 pb-36">
    </el-pagination>
    <el-dialog title="预约编辑" :visible.sync="editDialog" size="tiny" width="600px" center>
      <div class="flex fdr aic">
        <div class="dataForm">
          <div class="dataForm__item">
            <div class="dataForm__name">ID</div>
            <el-input v-model="detailInfo.apid" placeholder="" size="mini" class="dataForm__input" :disabled="true"></el-input>
          </div>
          <div class="dataForm__item mt-20">
              <div class="dataForm__name">预约项目</div>
              <adRegisterSelect v-model="detailInfo.arid" :lists.sync="registerLists" :need-edit="true"/>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">用户ID:</div>
            <el-input v-model="detailInfo.uid" placeholder="" size="mini" class="dataForm__input" :disabled="detailInfo.apid != 0"></el-input>
          </div>
          <div class="dataForm__item mt-16">
            <div class="dataForm__name">限额方式</div>
            <el-radio-group v-model="detailInfo.mode">
              <div class="dib mr-20">
                <el-radio :label="0">按照金额</el-radio>
                <el-radio :label="1">按照单数</el-radio>
              </div>
            </el-radio-group>
          </div>
          <div class="dataForm__item mt-16">
            <div class="dataForm__name">预约额度</div>
            <el-input v-model="detailInfo.quota" placeholder="" size="mini" class="dataForm__input">
              <template slot="append" v-if="detailInfo.mode === 0">￥</template>
              <template slot="append" v-if="detailInfo.mode === 1">单</template>
            </el-input>
          </div>
          <div class="dataForm__item mt-16">
            <div class="dataForm__name">日期</div>
            <el-date-picker v-model="detailInfo.date" type="date" placeholder="选择日期"> </el-date-picker>
          </div>
          <div class="dataForm__item mt-16">
            <div class="dataForm__name">状态</div>
            <el-radio-group v-model="detailInfo.status">
              <div class="dib mr-20">
                <el-radio :label="0">待安排</el-radio>
                <el-radio :label="1">已安排</el-radio>
                <el-radio :label="2">不安排</el-radio>
              </div>
            </el-radio-group>
          </div>
        </div>
      </div>
      <div class="flex fdc aic">
        <div class="flex mt-30">
          <div class="blue-large-btn mr-20" @click="adPredictEdit">保存</div>
          <div class="gray-large-btn" @click="editDialog = false">取消</div>
        </div>
      </div>
    </el-dialog>
  </article>
</template>

<script>
import {adPredictLists, adPredictEdit, downloadAdPredictLists} from '../../../api/api'
import util from '../../../script/util'
import adRegisterSelect from '../../../components/data-select/adRegisterSelect.vue'
export default {
  name: 'adPredict',
  components: {
    adRegisterSelect,
  },
  data () {
    return {
      opid: '',
      filters: {
        p: 1,
        l: 20,
        total: 0,
        arid: '',
        uid: '',
        status: ''
      },
      statusList: [
        {
          name: '所有',
          value: ''
        },
        {
          name: '待安排',
          value: 0
        },
        {
          name: '已安排',
          value: 1
        },
        {
          name: '不安排',
          value: 2
        }
      ],
      registerLists: [],
      lists: [],
      listLoading: false,
      editDialog: false,
      detailInfo: {
        apid: 0,
        arid: '',
        uid: '',
        mode: 0,
        quota: '',
        status: 0,
        date: ''
      }
    }
  },
  methods: {
    handleSizeChange (val) {
      this.filters.l = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.filters.p = val
      this.getList()
    },
    // 格式化时间
    formatTimeStamp (time) {
      return util.formatTimeStamp(time)
    },
    editInfo (index) {
      this.editDialog = true
      for (let key in this.detailInfo) {
        this.detailInfo[key] = this.lists[index][key]
      }

      this.detailInfo.date = new Date(this.detailInfo.date)
    },
    download (choose) {
      let filters = this.filters

      if (filters.arid === '') {
        this.$notify({
          title: '失败',
          message: '请先选择项目',
          type: 'error'
        })
        return
      }

      let link = downloadAdPredictLists + '?arid=' + filters.arid

      window.open(link, 'a')
    },
    saveInfo (params) {
      adPredictEdit(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '保存成功',
            type: 'success'
          })
          this.editDialog = false
          for (let key in this.detailInfo) {
            this.detailInfo[key] = ''
          }
          this.detailInfo.apid = 0
          this.detailInfo.status = 1
          this.getList()
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    changeInfo (index) {
      let apid = this.lists[index].apid
      let status = this.lists[index].status

      let params = {
        apid: apid,
        status: status
      }

      this.saveInfo(params)
    },
    adPredictEdit () {
      let params = util.cloneObj(this.detailInfo)

      params['date'] = parseInt(this.detailInfo.date.getTime() / 1000)

      let content = ''

      if (params['arid'] === '') {
        content = '请选择项目'
      }

      if (params['uid'] === '') {
        content = '请填写用户'
      }

      if (params['quota'] === '') {
        content = '请填写额度'
      }

      if (content) {
        this.$notify({
          title: '失败',
          message: content,
          type: 'error'
        })
        return
      }

      this.saveInfo(params)
    },
    getList () {
      let filters = this.filters
      let params = {
        p: filters.p,
        l: filters.l
      }

      if (filters.arid !== '') {
        params.arid = filters.arid
      }

      if (filters.uid !== '') {
        params.uid = filters.uid
      }

      if (filters.status !== '') {
        params.status = filters.status
      }

      this.listLoading = true
      adPredictLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.lists = data.d.lists
          this.filters.total = data.d.total
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
        this.$notify({
          title: '失败',
          message: '服务器出错了',
          type: 'error'
        })
      })
    }
  },
  mounted () {
    this.filters.arid = parseInt(this.$route.query.arid || 0)

    this.getList()
  },
  updated () {
    this.$nextTick(() => {
      this.$refs['dataTable'].doLayout()
      this.$refs['dataTable'].bodyWrapper.scrollTop = 0
    })
  },
  watch: {
    'filters.arid': 'getList',
    'filters.uid': 'getList',
    'filters.status': 'getList'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/module/ad/adPredict.vue